import React from 'react';
import Nav from '../components/Nav';
import Hero from '../components/Hero';
import StatsBar from '../components/StatsBar';
import Showreel from '../components/Showreel';
import BrandsMarquee from '../components/BrandsMarquee';
import GroupSection from '../components/GroupSection';
import Experience from '../components/Experience';
import Toolkit from '../components/Toolkit';
import Notable from '../components/Notable';
import Education from '../components/Education';
import Footer from '../components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-[#0a0a0a] text-neutral-100">
      <Nav />
      <main>
        <Hero />
        <StatsBar />
        <Showreel />
        <BrandsMarquee />
        <GroupSection />
        <Experience />
        <Toolkit />
        <Notable />
        <Education />
      </main>
      <Footer />
    </div>
  );
}
